module.exports = __webpack_public_path__ + "img/tether.f015e18e.png";